import axios from "axios";

export const apiPayment = axios.create({
  baseURL:
    process.env.REACT_APP_PAYMENT_AUTH ||
    "https://ms-payment-dev.velotax.com.br",
  headers: {
    "x-api-provider": "crypto-mynt",
  },
});
